import React, { createContext, useMemo, useState } from 'react';
import useUserData from '../../hooks/useUserData';
import { Helmet } from 'react-helmet';

export const UserContext = createContext();

const UserContextProvider = ({ children }) => {

    const userToken = localStorage.getItem("userToken");

    const userData = useMemo(() => {
        const user = localStorage.getItem("userData");
        return JSON.parse(user);
    }, []);

    const { simpleUser, consultantData, permissions } = useUserData(userToken, userData);

    return (
        <UserContext.Provider value={{ userToken, userData, simpleUser, consultantData, permissions, iranianIdentityCardValidation, validateMobile }}>
            {children}
        </UserContext.Provider>
    );

    function iranianIdentityCardValidation(value) {
        if (typeof value === 'undefined' || !value) {
            return false;
        }
        const check = parseInt(value[9], 10);
        let sum = 0;
        for (let i = 0; i < 9; i += 1) {
            sum += parseInt(value[i], 10) * (10 - i);
        }
        sum %= 11;
        const result = (sum < 2 && check === sum) || (sum >= 2 && check + sum === 11);
        return result;
    };

    function validateMobile(number, type) {
        if (type === 'mobile') {
            const regex = /^09(1[0-9]|9[0-9]|3[0-9]|0[1-5]|2[0-2])-?[0-9]{3}-?[0-9]{4}$/;
            if (regex.test(number)) {
                return true;
            } else {
                return false;
            }
        } else {
            const regex = /^0[0-9]{2,}[0-9]{7,}$/;
            if (regex.test(number)) {
                return true;
            } else {
                return false;
            }
        }
    }

};

export default UserContextProvider;